import PropTypes from "prop-types";
import Dispatcher from "Dispatcher";
import typeCheckingStore from "data/util/typeCheckingStore";
import { ReduceStore } from "flux/utils";
import BrowserActions from "data/BrowserActions";

const measureWindow = () => ({
    height: window.innerHeight,
    width: window.innerWidth,
});

class BrowserStore extends ReduceStore {

    getInitialState() {
        return {
            size: measureWindow(),
        };
    }

    reduce(state, action) {
        switch (action.type) {

            case BrowserActions.RESIZE: {
                return {
                    ...state,
                    size: measureWindow(),
                };
            }

            default:
                return state;
        }
    }

    getSize() {
        return this.getState().size;
    }
}

BrowserStore.stateTypes = {
    size: PropTypes.shape({
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
    }).isRequired,
};

export default typeCheckingStore(new BrowserStore(Dispatcher));



// WEBPACK FOOTER //
// ./app/data/BrowserStore.js